var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/city.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"c-form__field\">\n\n        <label for=\"address.city\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 4, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-globalFormField-city",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += " &#42;</label>\n\n        <input type=\"text\" name=\"address.city\" id=\"address.city\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 6, colno = 83, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"city"), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" required aria-required=\"true\" data-cm-element='city' data-qa-address-form-city-field aria-describedby=\"address.city_error\"/>\n\n    <span class=\"c-form-message\"data-qa-error-field=\"city\" id=\"address.city_error\">";
output += runtime.suppressValue((lineno = 8, colno = 84, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_validations-city",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</span>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/city.j2"] , dependencies)